import Holidays from 'date-holidays';
import moment from 'moment';

import { getFridayAfterThanksgiving, parseHolidayDay } from './holidaysCalculations';

export const UI_DATE_FORMAT_STRING = 'MM/DD/YYYY'; // used for showing dates for users
export const UI_DATE_TIME_FORMAT_STRING = 'M/DD/YYYY H:mm'; // used for showing date time for users
export const DATE_FORMAT_STRING = 'MM/DD/YYYY';
export const DB_DATE_FORMAT_STRING = 'YYYY-MM-DD';
export const DB_DATETIME_FORMAT_STRING = 'YYYY-MM-DD HH:mm';
export const TIMESTAMP_FORMAT_STRING = 'YYYY-MM-DDTHH:mm:ss';

export const parseDate = (
  date: string,
  format: string = `${DATE_FORMAT_STRING}, HH:mm A`
): string => {
  return moment(date, DB_DATE_FORMAT_STRING).format(format);
};

export const parseTimestamp = (
  date: string,
  format: string = `${DATE_FORMAT_STRING}, HH:mm A`
): string => {
  return moment(date, TIMESTAMP_FORMAT_STRING).format(format);
};

export const parseDateNoTime = (date: string, format: string = DATE_FORMAT_STRING): string => {
  return parseDate(date, format);
};

export const parseTimeTo = (timeTo: string): string => {
  return timeTo === '0:00' ? '23:59:59' : timeTo;
};

export const getHourFormatted = (hour: string): string => {
  return moment(`2000-01-01 ${hour}`, DB_DATETIME_FORMAT_STRING).format(
    'h:mma'
  );
};
export const parseTime = (
  datetime: string,
  format: string = UI_DATE_TIME_FORMAT_STRING
): string => {
  return moment(datetime).format(format);
};

export const getUSHolidaysSafe = (): string[] => {
  const currentYear = getUSHolidays();
  const nextYear = getUSHolidays(moment().add(1, 'year').year());
  return [...currentYear, ...nextYear, getFridayAfterThanksgiving()];
};

export const getUSHolidays = (year: number = moment().year()): string[] => {
  return new Holidays('US', 'DC', { types: ['public'] })
    .getHolidays(year)
    .map((o) => parseHolidayDay(o));
};
